import type { TableHeaderRow } from '@shared/table-generator';

const defaultColumnHeader: TableHeaderRow['children'][0] = {
  id: 'col-qset',
  children: 'QSets',
  align: 'center' as const,
};

export default function generateColumns(data: string[]) {
  return [
    {
      children: [
        defaultColumnHeader,
        ...data.map((col) => {
          return {
            children: col,
            align: 'center' as const,
          };
        }),
      ],
    },
  ];
}
